import { TLoanApplicationDTO } from './types/DTO/loanApplication';

const params = new URLSearchParams(window.location.search);
const knownMockParams = ['mockIndicativeOffer'];
const shouldMock =
  import.meta.env.MODE !== 'production' &&
  knownMockParams.some((param) => params.has(param));

if (shouldMock) {
  import('msw').then(({ http, HttpResponse }) => {
    import('msw/browser').then(({ setupWorker }) => {
      const handlers = [];

      // Indicative offer handler start
      const createIndicativeOfferHandler = (
        response: TLoanApplicationDTO['getIndicativeOfferRes']
      ) =>
        http.get(
          `${
            import.meta.env.VITE_API_SVC_ONBOARDING_BASE_URL
          }/country/*/indicative-offer/*`,
          () => {
            return HttpResponse.json(response);
          }
        );

      if (params.has('mockIndicativeOffer')) {
        handlers.push(
          createIndicativeOfferHandler({
            showIndicativeOffer: true,
            minAmount: 80000,
            maxAmount: 250000,
          })
        );
      }
      // Indicative offer handler end

      const worker = setupWorker();
      worker.start({ onUnhandledRequest: 'bypass' });
      worker.use(...handlers);
    });
  });
}
